'use strict';

exports.__esModule = true;
exports.headingParser = exports.trackCurrentIndex = exports.trackHeadings = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // ------------------------------------------------------------------------------
// ---------------------------------------------------------------------- Imports
// ------------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries


// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _typography = require('@bodhi-project/typography');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstract stuff
var Fragment = _react2.default.Fragment;
var H2 = _typography.Elements.H2,
    H3 = _typography.Elements.H3,
    H4 = _typography.Elements.H4,
    H5 = _typography.Elements.H5,
    H6 = _typography.Elements.H6;

/**
 * Deep diff between two object, using lodash
 * @param  {Object} object Object compared
 * @param  {Object} base   Object to compare with
 * @return {Object}        Return a new object who represent the diff
 */

function diff(object, base) {
  function changes(object, base) {
    return _lodash2.default.transform(object, function (result, value, key) {
      if (!_lodash2.default.isEqual(value, base[key])) {
        result[key] = _lodash2.default.isObject(value) && _lodash2.default.isObject(base[key]) ? changes(value, base[key]) : value;
      }
    });
  }
  return changes(object, base);
}

/**
  * trackHeadings
  */
var trackHeadings = exports.trackHeadings = function trackHeadings(astElement, headings) {
  switch (astElement.depth) {
    case 1:
      return _extends({}, headings, { depths: _extends({}, headings.depths, { first: headings.depths.first + 1 }) });
    case 2:
      return _extends({}, headings, { depths: _extends({}, headings.depths, { second: headings.depths.second + 1 }) });
    case 3:
      return _extends({}, headings, { depths: _extends({}, headings.depths, { third: headings.depths.third + 1 }) });
    case 4:
      return _extends({}, headings, { depths: _extends({}, headings.depths, { fourth: headings.depths.fourth + 1 }) });
    case 5:
      return _extends({}, headings, { depths: _extends({}, headings.depths, { fifth: headings.depths.fifth + 1 }) });
    default:
      return _extends({}, headings);
  }
};

var whatChangedX = function whatChangedX(obj) {
  switch (_lodash2.default.keys(obj)[0]) {
    case 'first':
      return 1;
    case 'second':
      return 2;
    case 'third':
      return 3;
    case 'fourth':
      return 4;
    case 'fifth':
      return 5;
    default:
      return undefined;
  }
};

/* eslint-disable prefer-template */
/**
  * trackCurrentIndex
  */
var trackCurrentIndex = exports.trackCurrentIndex = function trackCurrentIndex(prevHeadings, thisHeadings, firstHeadingInstance) {
  var first = 0;
  var second = 0;
  var third = 0;
  var fourth = 0;
  var fifth = 0;
  var dirty = [];

  if (firstHeadingInstance) {
    first = !_lodash2.default.isUndefined(thisHeadings.depths.first) && thisHeadings.depths.first !== 0 ? thisHeadings.depths.first : 0;
    second = !_lodash2.default.isUndefined(thisHeadings.depths.second) && thisHeadings.depths.second !== 0 ? thisHeadings.depths.second : 0;
    third = !_lodash2.default.isUndefined(thisHeadings.depths.third) && thisHeadings.depths.third !== 0 ? thisHeadings.depths.third : 0;
    fourth = !_lodash2.default.isUndefined(thisHeadings.depths.fourth) && thisHeadings.depths.fourth !== 0 ? thisHeadings.depths.fourth : 0;
    fifth = !_lodash2.default.isUndefined(thisHeadings.depths.fifth) && thisHeadings.depths.fifth !== 0 ? thisHeadings.depths.fifth : 0;
    dirty = [first, second, third, fourth, fifth];
  } else {
    var trackers = prevHeadings.currentIndex.dirty;

    var whatChanged = whatChangedX(diff(prevHeadings.depths, thisHeadings.depths));
    var popped = _lodash2.default.split(prevHeadings.currentIndex.pretty, '.');

    first = whatChanged === 1 ? trackers[0] + 1 : trackers[0];
    second = whatChanged === 2 ? trackers[1] + 1 : trackers[1];
    third = whatChanged === 3 ? trackers[2] + 1 : trackers[2];
    fourth = whatChanged === 4 ? trackers[3] + 1 : trackers[3];
    fifth = whatChanged === 5 ? trackers[4] + 1 : trackers[4];
    dirty = [first, second, third, fourth, fifth];

    if (!(whatChanged >= popped.length)) {
      dirty = [].concat(_lodash2.default.slice(dirty, 0, whatChanged), _lodash2.default.fill(Array(5 - whatChanged), 0));
    }
  }

  var currentIndex = {
    pretty: _lodash2.default.join(_lodash2.default.filter(dirty, function (x) {
      return x !== 0;
    }), '.') + '.',
    dirty: dirty
  };

  return _extends({}, thisHeadings, { currentIndex: currentIndex });
};
/* eslint-enable prefer-template */

/**
  * headingParser
  */
var headingParser = exports.headingParser = function headingParser(astElement, headings) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // console.log(headings);
  var id = _lodash2.default.kebabCase(_lodash2.default.toLower(_lodash2.default.trim(astElement.children[0].value)));
  var link = '#' + id;
  switch (astElement.depth) {
    case 1:
      return _react2.default.createElement(
        H2,
        {
          key: '' + headings.depths.first,
          style: { position: 'relative' },
          id: id
        },
        options.linkHeaders ? _react2.default.createElement(
          Fragment,
          null,
          _react2.default.createElement(
            'a',
            { href: link, className: 'd' },
            '#'
          ),
          _react2.default.createElement(
            'a',
            { href: link, className: 'a' },
            options.trackHeaders ? _react2.default.createElement(
              Fragment,
              null,
              headings.currentIndex.pretty,
              '\xA0',
              astElement.children[0].value
            ) : _react2.default.createElement(
              Fragment,
              null,
              astElement.children[0].value
            )
          )
        ) : _react2.default.createElement(
          Fragment,
          null,
          options.trackHeaders ? _react2.default.createElement(
            Fragment,
            null,
            headings.currentIndex.pretty,
            '\xA0',
            astElement.children[0].value
          ) : _react2.default.createElement(
            Fragment,
            null,
            astElement.children[0].value
          )
        )
      );
    case 2:
      return _react2.default.createElement(
        H3,
        {
          key: headings.depths.first + '.' + headings.depths.second,
          style: { position: 'relative' },
          id: id
        },
        options.linkHeaders ? _react2.default.createElement(
          Fragment,
          null,
          _react2.default.createElement(
            'a',
            { href: link, className: 'd' },
            '#'
          ),
          _react2.default.createElement(
            'a',
            { href: link, className: 'a' },
            options.trackHeaders ? _react2.default.createElement(
              Fragment,
              null,
              headings.currentIndex.pretty,
              '\xA0',
              astElement.children[0].value
            ) : _react2.default.createElement(
              Fragment,
              null,
              astElement.children[0].value
            )
          )
        ) : _react2.default.createElement(
          Fragment,
          null,
          options.trackHeaders ? _react2.default.createElement(
            Fragment,
            null,
            headings.currentIndex.pretty,
            '\xA0',
            astElement.children[0].value
          ) : _react2.default.createElement(
            Fragment,
            null,
            astElement.children[0].value
          )
        )
      );
    case 3:
      return _react2.default.createElement(
        H4,
        {
          key: headings.depths.first + '.' + headings.depths.second + '.' + headings.depths.third,
          style: { position: 'relative' },
          id: id
        },
        options.linkHeaders ? _react2.default.createElement(
          Fragment,
          null,
          _react2.default.createElement(
            'a',
            { href: link, className: 'd' },
            '#'
          ),
          _react2.default.createElement(
            'a',
            { href: link, className: 'a' },
            options.trackHeaders ? _react2.default.createElement(
              Fragment,
              null,
              headings.currentIndex.pretty,
              '\xA0',
              astElement.children[0].value
            ) : _react2.default.createElement(
              Fragment,
              null,
              astElement.children[0].value
            )
          )
        ) : _react2.default.createElement(
          Fragment,
          null,
          options.trackHeaders ? _react2.default.createElement(
            Fragment,
            null,
            headings.currentIndex.pretty,
            '\xA0',
            astElement.children[0].value
          ) : _react2.default.createElement(
            Fragment,
            null,
            astElement.children[0].value
          )
        )
      );
    case 4:
      return _react2.default.createElement(
        H5,
        {
          key: headings.depths.first + '.' + headings.depths.second + '.' + headings.depths.third + '.' + headings.depths.fourth,
          style: { position: 'relative' },
          id: id
        },
        options.linkHeaders ? _react2.default.createElement(
          Fragment,
          null,
          _react2.default.createElement(
            'a',
            { href: link, className: 'd' },
            '#'
          ),
          _react2.default.createElement(
            'a',
            { href: link, className: 'a' },
            options.trackHeaders ? _react2.default.createElement(
              Fragment,
              null,
              headings.currentIndex.pretty,
              '\xA0',
              astElement.children[0].value
            ) : _react2.default.createElement(
              Fragment,
              null,
              astElement.children[0].value
            )
          )
        ) : _react2.default.createElement(
          Fragment,
          null,
          options.trackHeaders ? _react2.default.createElement(
            Fragment,
            null,
            headings.currentIndex.pretty,
            '\xA0',
            astElement.children[0].value
          ) : _react2.default.createElement(
            Fragment,
            null,
            astElement.children[0].value
          )
        )
      );
    case 5:
      return _react2.default.createElement(
        H6,
        {
          key: headings.depths.first + '.' + headings.depths.second + '.' + headings.depths.third + '.' + headings.depths.fourth + '.' + headings.depths.fifth,
          style: { position: 'relative' },
          id: id
        },
        options.linkHeaders ? _react2.default.createElement(
          Fragment,
          null,
          _react2.default.createElement(
            'a',
            { href: link, className: 'd' },
            '#'
          ),
          _react2.default.createElement(
            'a',
            { href: link, className: 'a' },
            options.trackHeaders ? _react2.default.createElement(
              Fragment,
              null,
              headings.currentIndex.pretty,
              '\xA0',
              astElement.children[0].value
            ) : _react2.default.createElement(
              Fragment,
              null,
              astElement.children[0].value
            )
          )
        ) : _react2.default.createElement(
          Fragment,
          null,
          options.trackHeaders ? _react2.default.createElement(
            Fragment,
            null,
            headings.currentIndex.pretty,
            '\xA0',
            astElement.children[0].value
          ) : _react2.default.createElement(
            Fragment,
            null,
            astElement.children[0].value
          )
        )
      );
    default:
      return _react2.default.createElement(Fragment, null);
  }
};

headingParser.propTypes = process.env.NODE_ENV !== "production" ? {} : {};


//////////////////
// WEBPACK FOOTER
// ./~/@bodhi-project/markdown-to-react/lib/parsers/headingParser.js
// module id = 438
// module chunks = 168707334958949